import nameSurname from './namesSurnames';
import allStats from './allStats';
import allStatsForGame from './allStatsForGame';

const seasonTraining = (data,posicionEnLiga) => {
    //se generan 3 jugadores, que serán mas buenos si se ha quedado peor en liga
    //siempre entre 18 y 19 años
    //posicionEnLiga 0 es primero y 19 ultimo
    posicionEnLiga += 10
    posicionEnLiga = posicionEnLiga/6
    
    for(let i = 0; i < 3; i++){
        let myPlayer = {name: nameSurname(), skills: generateRandomNumber(Math.floor(posicionEnLiga*10),Math.floor(posicionEnLiga*15),7), broom: [20,20,20,20], hiddenSkills: generateRandomNumber(1,99,2), age: generateOneRandom(18,19), stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname: ''}
        data.teams[0].players.push(myPlayer)
    }

    return data
}

function generateRandomNumber(from, to, howMany) {
    const diferencia = to - from + 1;
    let numbers = [];
    for(let i = 0; i < howMany; i++) {
      numbers[i] = Math.floor(Math.random() * diferencia + from);
    }
    return numbers;
}
function generateOneRandom(from, to){
    const diferencia = to - from + 1;
    return Math.floor(Math.random() * diferencia + from)
  }

export default seasonTraining